import { render, staticRenderFns } from "./ViewProductDetails.vue?vue&type=template&id=296806a8&scoped=true"
import script from "./ViewProductDetails.vue?vue&type=script&lang=js"
export * from "./ViewProductDetails.vue?vue&type=script&lang=js"
import style0 from "./ViewProductDetails.vue?vue&type=style&index=0&id=296806a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296806a8",
  null
  
)

export default component.exports